import { openBlock as l, createElementBlock as e, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#338AF3",
  d: "M40 20c0-7.93-4.614-14.78-11.304-18.016v36.031C35.386 34.78 40 27.93 40 20ZM0 20c0 7.93 4.615 14.78 11.305 18.015V1.985C4.615 5.218 0 12.07 0 20Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#ACABB1",
  d: "M25.227 23.382 21.845 20l3.219-3.22-.146-1.7-.922-.92L20 18.154l-3.996-3.996-.922.922-.146 1.7 3.22 3.22-3.382 3.38 1.844 1.845L20 21.845l3.382 3.381 1.845-1.844Z"
}, null, -1), a = /* @__PURE__ */ t("path", {
  fill: "#6DA544",
  d: "m24.919 15.081-1.845 1.845a4.348 4.348 0 1 1-6.149 0l-1.844-1.845a6.956 6.956 0 1 0 9.838 0Z"
}, null, -1), d = [
  n,
  c,
  s,
  a
];
function i(_, h) {
  return l(), e("svg", o, [...d]);
}
const f = { render: i };
export {
  f as default,
  i as render
};
